const styles = {

  filtercontainer: {
    display: 'flex',
    overflowX: 'scroll',
    overflowY: 'none',
    flexWrap: 'nowrap',
    paddingX: 1,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar:horizontal': {
      display: 'none',
    },
    '&::-webkit-scrollbar:vertical': {
      display: 'none',
    },
    '&::-webkit-scrollbar-track': {
      display: 'none',
    },
  },
  button: {
    height: 24,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    mb: 1,
    backgroundColor: (theme) => `${theme.palette.primary.contrastText}!important`,
    borderColor: (theme) => `${theme.palette.background.border}!important`,
    '&.MuiButton-outlined:hover': {
      borderColor: (theme) => `${theme.palette.background.border}!important`,
      backgroundColor: (theme) => `${theme.palette.primary.light}!important`,
    },
  },

  buttonVariant: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    backgroundColor: 'background.grey900',
    width: 'fit-content',
    zIndex: 2,
    p: 1.2,
    borderRadius: 1,
    '&:hover': {
      backgroundColor: 'background.grey400',
    },
  },

  filter: {
    display: 'flex',
    paddingLeft: 8.5,
  },
}

export default styles
